export const TEST_ID = 'mapControlPopup';

export { POINT_MODE } from 'components/Map/constants';
